import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@material-ui/core";
import styled from "styled-components";
import {
  resolveOccurrenceColor,
  resolveOccurrenceIcon
} from "../../utils/occurrenceVisual";

const TypeIcon = styled(Icon)`
  && {
    font-size: ${props => props.$size || 24}px;
    color: ${props => props.$color || "#546E7A"};
  }
`;

export default function OccurrenceIcon({ occurrence, fallbackColor, size }) {
  if (!occurrence) {
    return null;
  }
  return (
    <TypeIcon
      $color={resolveOccurrenceColor(occurrence, fallbackColor)}
      $size={size}
    >
      {resolveOccurrenceIcon(occurrence)}
    </TypeIcon>
  );
}

OccurrenceIcon.propTypes = {
  occurrence: PropTypes.object,
  fallbackColor: PropTypes.string,
  size: PropTypes.number
};

OccurrenceIcon.defaultProps = {
  occurrence: null,
  fallbackColor: undefined,
  size: 24
};
